import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="auto-dismiss"
// Dismisses the element after delayValue ms (once). Pauses the countdown on
// hover/focus and resumes on leave, so the reader is never rushed. Manual
// close via an action; min display floor avoids a flicker.
export default class extends Controller {
  static values = { delay: { type: Number, default: 6000 } }

  connect() {
    this.remaining = this.delayValue
    this.start()
    this.element.addEventListener("mouseenter", this.pause)
    this.element.addEventListener("mouseleave", this.start)
    this.element.addEventListener("focusin", this.pause)
    this.element.addEventListener("focusout", this.start)
  }

  disconnect() {
    clearTimeout(this.timer)
    this.element.removeEventListener("mouseenter", this.pause)
    this.element.removeEventListener("mouseleave", this.start)
    this.element.removeEventListener("focusin", this.pause)
    this.element.removeEventListener("focusout", this.start)
  }

  start = () => {
    clearTimeout(this.timer)
    this.startedAt = Date.now()
    this.element.classList.remove("is-paused")
    this.timer = setTimeout(() => this.close(), this.remaining)
  }

  pause = () => {
    clearTimeout(this.timer)
    this.remaining -= Date.now() - this.startedAt
    this.element.classList.add("is-paused")
  }

  close() {
    clearTimeout(this.timer)
    this.element.classList.add("is-leaving")
    // Let the exit transition play, then remove.
    setTimeout(() => this.element.remove(), 250)
  }
}
